module.exports = __webpack_public_path__ + "static/media/audio_placeholder.e132cacb.jpg";